import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ActionResponse } from 'src/app/models/action-response';
import { ReplaceProductServiceDueDatesStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/init-step/due-dates-step';
import { ReplaceProductServiceInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/init-step/init-step';
import { ReplaceProductServiceBillingStep26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/replace-product-service-billing-step/replace-product-service-billing-step-v26';
import { ReplaceProductServiceReplacementStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/replace-product-service-replacement-step/replace-product-service-replacement-step-v26';
import * as fromReplaceProductServiceWizardV26 from './reducer';
import { State } from './state';

export const selectReplaceProductServiceWizardState = createFeatureSelector<State>(
  fromReplaceProductServiceWizardV26.replaceProductServiceWizardFeatureKey,
);

export const selectInitStep = createSelector(
  selectReplaceProductServiceWizardState,
  (state: State): ReplaceProductServiceInitStepV26 => state.initStep,
);

export const selectDueDateStep = createSelector(
  selectReplaceProductServiceWizardState,
  (state: State): ReplaceProductServiceDueDatesStepV26 => state.dueDatesStep,
);

export const selectReplacementStep = createSelector(
  selectReplaceProductServiceWizardState,
  (state: State): ReplaceProductServiceReplacementStepV26 => state.replacementStep,
);

export const selectBillingStep = createSelector(
  selectReplaceProductServiceWizardState,
  (state: State): ReplaceProductServiceBillingStep26 => state.billingStep,
);

export const selectReplaceProductServiceState = createSelector(
  selectReplaceProductServiceWizardState,
  (state: State): ActionResponse => state.response,
);

export const selectErrorMessage = createSelector(selectReplaceProductServiceWizardState, (state: State): any => state.errorMessage);
